import { Notifications, Edit, Event } from '@mui/icons-material';
import {
  Avatar,
  Badge,
  Box,
  IconButton,
  Menu,
  MenuItem,
  Tooltip,
  Typography,
} from '@mui/material';
import { Link } from 'react-router-dom';
import React from 'react';

const getRandomPastelColor = (name) => {
  const hash = [...name].reduce((acc, char) => acc + char.charCodeAt(0), 0);
  const hue = hash % 360;
  return `hsl(${hue}, 70%, 80%)`;
};

const formatName = (name) => {
  return name
    .split(/\s+/)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

const HeaderActions = ({
  ACM,
  typeOfUser,
  user,
  notificationCount,
  notificationAnimation,
  anchorElUser,
  handleOpenReminders,
  handleShowNotifications,
  handleOpenUserMenu,
  handleCloseUserMenu,
  settingClickHandler,
  updateSelectedMenu,
  HeaderSettings,
}) => {
  return (
    <Box className='flexBox' sx={{ flexGrow: 0 }}>
      {ACM[typeOfUser]?.notificationServices && (
        <Tooltip title='Set Reminders'>
          <IconButton onClick={handleOpenReminders}>
            <Event />
          </IconButton>
        </Tooltip>
      )}
      <Tooltip title='Edit your profile'>
        <IconButton
          component={Link}
          to='/settings'
          onClick={() => {
            updateSelectedMenu('Settings');
          }}
        >
          <Edit />
        </IconButton>
      </Tooltip>

      {ACM[typeOfUser]?.canViewNotifications && (
        <Tooltip title='Notifications'>
          <IconButton onClick={handleShowNotifications} sx={{ mr: 2 }}>
            <Badge
              color='secondary'
              overlap='circular'
              badgeContent={
                notificationCount > 0 ? notificationCount : null
              }
              className={notificationAnimation ? 'notification-badge-pulse' : ''}
            >
              <Notifications className={notificationAnimation ? 'notification-icon-shake' : ''} />
            </Badge>
          </IconButton>
        </Tooltip>
      )}
      <Tooltip title='Open settings'>
        <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
          <Avatar
            src={user?.photoURL || undefined}
            sx={{
              bgcolor: !user?.photoURL
                ? getRandomPastelColor(user?.fullname || user?.displayName || '')
                : 'transparent',
              color: !user?.photoURL ? '#000' : 'inherit',
              fontWeight: 600,
              fontSize: '1.25rem',
            }}
          >
            {!user?.photoURL &&
              (user?.fullname?.[0]?.toUpperCase() ||
                user?.displayName?.[0]?.toUpperCase() ||
                '?')}
          </Avatar>
        </IconButton>
      </Tooltip>
      <Menu
        sx={{ mt: '45px' }}
        id='menu-appbar'
        anchorEl={anchorElUser}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        keepMounted
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={Boolean(anchorElUser)}
        onClose={handleCloseUserMenu}
      >
        <MenuItem key={'welcome'} onClick={handleCloseUserMenu} disabled>
          <Typography textAlign='center'>
            Welcome,{' '}
            {formatName(
              user?.fullname ||
                user?.displayName ||
                user.organizationAdminName ||
                'User'
            )}
          </Typography>
        </MenuItem>

        {HeaderSettings.filter(
          (setting) =>
            !(ACM[typeOfUser]?.isAdmin && setting.key === 'dashboard')
        ).map((setting) => (
          <MenuItem
            key={setting.key}
            onClick={() => settingClickHandler(setting)}
          >
            <Typography textAlign='center'>{setting.text}</Typography>
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};

export default HeaderActions; 